/* eslint-disable @typescript-eslint/no-explicit-any */
export interface Callback {
	(...args: any[]): void;
}

export interface Callbacks {
	[key: string]: Callback[];
}

export class EventEmitter {
	private callbacks: Callbacks = {};

	constructor() {
		this.callbacks = {};
	}

	on(name: string, callback: Callback) {
		if (!this.callbacks[name]) {
			this.callbacks[name] = [];
		}

		this.callbacks[name].push(callback);
	}

	emit(name: string, ...data: any[]) {
		if (!this.callbacks[name]) {
			return;
		}

		this.callbacks[name].forEach((callback) => callback(...data));
	}
}
